import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a2566ce&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style/index.css?vue&type=style&index=0&id=1a2566ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2566ce",
  null
  
)

export default component.exports